import React, { useState, useEffect } from 'react'
import Sidebar from "./sidebar/Sidebar";
import axios from "axios"
import api from "../api/axios";
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
const AddNewCarbonRemovel = () => {
    const navigate = useNavigate()
    const location = useLocation();
    const dataToEdit = location.state?.data;
    const [sidebarToggle, setSidebarToggle] = useState(true);
    const [carbon, setCarbon] = useState("");
    const [gst, setGst] = useState("")


    useEffect(() => {
        if (dataToEdit) {
            setCarbon(dataToEdit.carbon || "")
            setGst(dataToEdit.gst || "")
        }
    }, [dataToEdit])

    //sidebar toggle
    const toggleClick = () => {
        setSidebarToggle(!sidebarToggle);
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        try {
            const payload = {
                carbon,
                gst
            }
            if (dataToEdit?._id) {
                await api.put(`/putcarbon/${dataToEdit._id}`, payload);
                toast.success("Update carbonremovel");
                navigate("/carbonremovel");
            } else {
                await api.post("/addcarbon", payload)
                toast.success("add carbon successfully")
                setCarbon("")
                setGst("")
            }
        } catch (error) {
            console.error(error)
        }
    }

    return (
        <div className="font-[Poppins] flex ">
            {sidebarToggle ? <div className="w-[320px] nirav"></div> : null}
            <Sidebar toggleClick={toggleClick} sidebarToggle={sidebarToggle} />
            <div className="w-[100%] ">
                <div className=" 2xl:w-[90%] w-[95%] m-auto 2xl:mt-16 mt-10  xl:p-2 lg:p-10  p-2">
                    <div className="sm:flex sm:justify-between sm:items-center">
                        <h1 className="font-medium 2xl:text-2xl text-xl">
                            Hello Admin 👋🏼
                        </h1>
                    </div>

                    <form onSubmit={handleFormSubmit} className="border 2xl:mt-10 mt-7 2xl:rounded-[30px] rounded-[20px] px-10 py-8 bg-white shadow-sm">
                        <p className='text-[#9197B3] font-medium text-xs'>Carbon removal /</p>
                        <h2 className='text-[#000000] font-semibold text-[22px]'>{dataToEdit ? "Edit Carbon " : "Add Carbon "}</h2>

                        <div className='border border-[#EBEBEB] mt-[28px] rounded-[10px] p-4'>
                            <div className='grid grid-cols-2 gap-4'>
                                <div>
                                    <label htmlFor="">Carbon</label><br />
                                    <input
                                        className="border rounded-md text-sm px-3 py-1 w-full mt-[4px]"
                                        placeholder="Enter carbon"
                                        type="text"
                                        value={carbon}
                                        onChange={(e) => setCarbon(e.target.value)}
                                    />
                                </div>
                                <div>
                                    <label htmlFor="">GST (%)</label><br />
                                    <input
                                        className="border rounded-md text-sm px-3 py-1 w-full mt-[4px]"
                                        placeholder="Enter gst"
                                        type="number"
                                        value={gst}
                                        onChange={(e) => setGst(e.target.value)}
                                    />
                                </div>
                            </div>

                        </div>
                        <div className='mt-[28px] text-end'>
                            <button
                                type='submit'
                                className=" cursor-pointer bg-[#C65B1D]  hover:shadow-md button text-white   rounded-lg px-8 py-2"
                            >
                                {dataToEdit ? "Update" : " Save"}

                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default AddNewCarbonRemovel
